import { useNavigate as useReactRouterNavigate, NavigateOptions } from 'react-router-dom'
import { appendMarketingParams } from '../utils/marketing-params'

/**
 * Custom hook that wraps React Router's useNavigate
 * Automatically appends marketing params to all navigation
 */
export function useNavigateWithParams() {
	const navigate = useReactRouterNavigate()

	return (to: string | number, options?: NavigateOptions) => {
		// If navigating with a number (e.g., -1 for back), just use default navigate
		if (typeof to === 'number') {
			return navigate(to)
		}

		// Append marketing params to the destination
		const urlWithParams = appendMarketingParams(to)
		return navigate(urlWithParams, options)
	}
}

